var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#fff","d":"M3.333 16.667v-5.834h.834v4.427L15.26 4.167h-4.427v-.834h5.834v5.834h-.834V4.74L4.741 15.833h4.426v.834H3.333Z"}));
}

Expand.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = Expand;

Expand.default = Expand;
